import React, { useRef } from 'react';
import VRMViewer from './VRMViewer';
import FloatingPanel from './FloatingPanel';

function VRMViewerWrapper() {
  const rendererRef = useRef(null);

  const handleButtonClick = () => {
    // Handle button click event
    //console.log('Button clicked!');
    rendererRef.current.startTube();
  };

  return (
    <div>
      <div ref={rendererRef}>
        <VRMViewer rendererRef={rendererRef} />
      </div>
      <FloatingPanel rendererRef={rendererRef}/>
    </div>
  );
}

export default VRMViewerWrapper;